import {
  Component,
  HostListener,
  inject,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import {
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';

import {
  AppLang,
  LanguageService,
} from '../../../../core/services/Language/lang.service';
import { ProfileService } from '../../../../core/services/Profile/profile.service';
import { Profile, ProfileData } from '../../models/profile-data.interface';

@Component({
  selector: 'app-dashboard-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrl: 'header.component.css',
})
export class DashboardHeaderComponent implements OnInit{
  private readonly languageService = inject(LanguageService);
  private readonly profileService=inject(ProfileService);
  private readonly platformId=inject(PLATFORM_ID);
  isMobileMenuOpen = false;
  isLangOpen = false;
  currentLang: AppLang = 'ar';
  profileData=signal<ProfileData | null>(null);




  constructor() {
    this.currentLang = this.languageService.getLang();
  }


  
   ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadProfileData()
    }
  }
  

  loadProfileData():void{
    this.profileService.getProfileData().subscribe({
       next: (res) => {
        this.profileData.set(res);
       },
      error: (err) => {
        console.error('profile load error:', err);
      }
    });
  }
    
 
   get shortName(): string {
  const fullName = this.profileData()?.profile?.full_legal_name || '';
  return fullName.split(' ').slice(0, 2).join(' ');
}

  toggleLang() {
    this.isLangOpen = !this.isLangOpen;
  }

  closeLang() {
    this.isLangOpen = false;
  }

  setLang(lang: AppLang) {
    this.languageService.setLang(lang);
    this.currentLang = lang;
    this.isLangOpen = false;
    this.isMobileMenuOpen = false;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.lang-toggle')) {
      this.isLangOpen = false;
    }
  }
}